import { render, staticRenderFns } from "./MsaView.vue?vue&type=template&id=2d6e7be2&scoped=true&"
import script from "./MsaView.vue?vue&type=script&lang=ts&"
export * from "./MsaView.vue?vue&type=script&lang=ts&"
import style0 from "./MsaView.vue?vue&type=style&index=0&id=2d6e7be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e7be2",
  null
  
)

export default component.exports